export function ColumnWidthsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      role="img"
      aria-label="Column Widths"
      {...props}
    >
      <path d="M10.3571 3.67857V12.3214H11.9286C12.1446 12.3214 12.3214 12.1446 12.3214 11.9286V4.07143C12.3214 3.85536 12.1446 3.67857 11.9286 3.67857H10.3571ZM9.17857 3.67857H6.82143V12.3214H9.17857V3.67857ZM5.64286 12.3214V3.67857H4.07143C3.85536 3.67857 3.67857 3.85536 3.67857 4.07143V11.9286C3.67857 12.1446 3.85536 12.3214 4.07143 12.3214H5.64286ZM2.5 4.07143C2.5 3.20469 3.20469 2.5 4.07143 2.5H11.9286C12.7953 2.5 13.5 3.20469 13.5 4.07143V11.9286C13.5 12.7953 12.7953 13.5 11.9286 13.5H4.07143C3.20469 13.5 2.5 12.7953 2.5 11.9286V4.07143Z" />
    </svg>
  );
}
